<template>
  <div class="invites">
    <section class="invites__hero">
      <div class="invites__hero-overlay" />
      <div class="invites__hero-content">
        <h1>Invités d'honneur</h1>
      </div>
    </section>

    <section class="invites__content">
      <div class="invites__inner">
        <p class="invites__intro">
          Ce week-end ne serait pas le même sans eux.
        </p>
        <p class="invites__text">
          Nos <strong>parents</strong>, piliers depuis toujours, et nos <strong>témoins</strong>,
          complices de chaque instant, auront une place toute particulière à nos côtés.
          Ils nous soutiennent, nous connaissent par cœur, et seront là pour nous
          entourer&hellip; et peut-être vous préparer quelques surprises.
        </p>

        <!-- Desktop layout -->
        <div class="invites__grid -desktop">
          <div class="invites__row -parents">
            <div
              v-for="w in parents"
              :key="w.firstName"
              class="invites__card"
            >
              <div class="invites__photo-wrap">
                <img
                  :src="w.photo"
                  :alt="w.firstName"
                  class="invites__photo"
                  :style="{ aspectRatio: w.ratio }"
                >
              </div>
              <p class="invites__name">
                {{ w.firstName }} {{ w.lastName }}
              </p>
              <p class="invites__name -mobile">
                <span>{{ w.firstName }}</span>
                <span>{{ w.lastName }}</span>
              </p>
              <p class="invites__role">
                {{ w.role }}
              </p>
            </div>
          </div>
          <div class="invites__row -witnesses">
            <div
              v-for="w in fourWitnesses"
              :key="w.firstName"
              class="invites__card"
            >
              <div class="invites__photo-wrap">
                <img
                  :src="w.photo"
                  :alt="w.firstName"
                  class="invites__photo"
                  :style="{ aspectRatio: w.ratio }"
                >
              </div>
              <p class="invites__name">
                {{ w.firstName }} {{ w.lastName }}
              </p>
              <p class="invites__name -mobile">
                <span>{{ w.firstName }}</span>
                <span>{{ w.lastName }}</span>
              </p>
              <p class="invites__role">
                {{ w.role }}
              </p>
            </div>
          </div>
          <div class="invites__row -officiant">
            <div class="invites__card">
              <div class="invites__photo-wrap">
                <img
                  :src="jb.photo"
                  :alt="jb.firstName"
                  class="invites__photo"
                  :style="{ aspectRatio: jb.ratio }"
                >
              </div>
              <p class="invites__name">
                {{ jb.firstName }} {{ jb.lastName }}
              </p>
              <p class="invites__name -mobile">
                <span>{{ jb.firstName }}</span>
                <span>{{ jb.lastName }}</span>
              </p>
              <p class="invites__role">
                {{ jb.role }}
              </p>
            </div>
          </div>
        </div>

        <!-- Tablet layout -->
        <div class="invites__grid -tablet">
          <div
            v-for="w in mobileOrder"
            :key="w.firstName"
            :class="['invites__card', { '-full': w.full }]"
          >
            <div class="invites__photo-wrap">
              <img
                :src="w.photo"
                :alt="w.firstName"
                class="invites__photo"
                :style="{ aspectRatio: w.ratio }"
              >
            </div>
            <p class="invites__name">
              {{ w.firstName }} {{ w.lastName }}
            </p>
            <p class="invites__name -mobile">
              <span>{{ w.firstName }}</span>
              <span>{{ w.lastName }}</span>
            </p>
            <p class="invites__role">
              {{ w.role }}
            </p>
          </div>
        </div>

        <div class="invites__divider" />

        <div class="invites__contact">
          <h2>Questions, demandes ou surprises&nbsp;?</h2>
          <p>
            Si vous avez la moindre question, une demande particulière ou même une idée
            de surprise (on adore), merci de <strong>contacter nos témoins</strong>,
            qui sont dans la confidence et aux commandes côté organisation.
          </p>
        </div>
      </div>
    </section>
  </div>
</template>

<script setup>
import photo5 from "../images/elisa.png"
import photo1 from "../images/ivy.png"
import photo3 from "../images/jade.jpeg"
import photo4 from "../images/jb.png"
import photo7 from "../images/parents_faliez.png"
import photo6 from "../images/parents_lechartier.png"
import photo2 from "../images/remi.png"

const parentsFaliez = { firstName: "René & Stefania", lastName: "Faliez", role: "Parents d'Elena", photo: photo7, ratio: "3 / 1.5", full: true }
const ivana = { firstName: "Ivana", lastName: "Faliez", role: "Témoin d'Elena", photo: photo1, ratio: "3 / 4" }
const elisa = { firstName: "Elisa", lastName: "Faliez", role: "Témoin d'Elena", photo: photo5, ratio: "3 / 4" }
const parentsLechartier = { firstName: "Alain & Berta", lastName: "Lechartier", role: "Parents d'Antoine", photo: photo6, ratio: "3 / 1.5", full: true }
const jade = { firstName: "Jade", lastName: "Lechartier", role: "Témoin d'Antoine", photo: photo3, ratio: "3 / 4" }
const remi = { firstName: "Rémi", lastName: "Esprabens", role: "Témoin d'Antoine", photo: photo2, ratio: "3 / 4" }
const jb = { firstName: "Jean-Baptiste", lastName: "Seferian", role: "Témoin et officiant de cérémonie", photo: photo4, ratio: "3 / 4" }

// Desktop: row 1 = parents, row 2 = 4 witnesses, row 3 = JB
const parents = [parentsFaliez, parentsLechartier]
const fourWitnesses = [ivana, elisa, jade, remi]

// Mobile: Faliez parents → Faliez sisters → Lechartier parents → Rémi & Jade → JB
const mobileOrder = [parentsFaliez, ivana, elisa, parentsLechartier, jade, remi, jb]
</script>

<style lang="scss" scoped>
@import "../base/mixins";

.invites__hero {
  position: relative;
  height: 50vh;
  min-height: 300px;
  display: flex;
  align-items: center;
  justify-content: center;
  text-align: center;
  background-image: url('../images/Amour-Etc.208.jpeg');
  background-size: 125%;
  background-position: 100% 50%;

  @media (max-width: $bp-mobile) {
    max-height: 300px;
    min-height: 300px;
    background-size: 160%;
    background-position: 80% 50%;
  }
}

.invites__hero-overlay {
  position: absolute;
  inset: 0;
  background: rgba($color-text-primary, 0.3);
}

.invites__hero-content {
  position: relative;
  z-index: 1;

  h1 {
    color: $color-white;
    font-weight: 300;
    letter-spacing: 0.05em;
  }
}

.invites__content {
  @include section-padding;
}

.invites__inner {
  @include container;
  text-align: center;
}

.invites__intro {
  @include heading;
  font-size: 1.4rem;
  font-weight: 300;
  margin-bottom: $spacing-element;

  @media (min-width: $bp-tablet) {
    font-size: 1.6rem;
  }
}

.invites__text {
  @include body-text;
  max-width: $container-wide;
  margin: 0 auto $spacing-block-lg;

  strong {
    font-weight: 400;
  }
}

.invites__grid {
  &.-desktop {
    display: none;

    @media (min-width: $bp-tablet) {
      display: block;
    }
  }

  &.-tablet {
    display: flex;
    flex-wrap: wrap;
    margin: 0 auto;
    justify-content: center;
    gap: $spacing-block;
    max-width: 500px;

    @media (min-width: $bp-tablet) {
      display: none;
    }
  }
}

.invites__row {
  display: flex;
  justify-content: center;
  gap: $spacing-block;
  margin-bottom: $spacing-block;

  &:last-child {
    margin-bottom: 0;
  }

  &.-parents .invites__card {
    width: calc(50% - $spacing-block / 2);
    max-width: 500px;
  }

  &.-witnesses .invites__card {
    width: calc(25% - $spacing-block * 3 / 4);
  }

  &.-officiant .invites__card {
    width: calc(25% - $spacing-block * 3 / 4);
  }
}

.invites__card {
  text-align: center;

  .invites__grid.-tablet & {
    width: calc(50% - $spacing-block / 2);

    &.-full {
      width: 100%;
    }
  }
}

.invites__photo-wrap {
  margin-bottom: $spacing-element;
}

.invites__photo {
  width: 100%;
  object-fit: cover;
}

.invites__name {
  @include heading;
  font-size: 1rem;
  font-weight: 500;
  margin-bottom: 2px;

  &.-mobile {
    display: none;
  }

  @media (max-width: $bp-mobile) {
    &:not(.-mobile) {
      display: none;
    }

    &.-mobile {
      display: flex;
      flex-direction: column;

      & > span:nth-of-type(2) {
        margin-top: -7px;
      }
    }
  }
}

.invites__role {
  @include body-text;
  font-size: 0.8rem;
  color: $color-text-secondary;
  letter-spacing: 0.1em;
  text-transform: uppercase;
}

.invites__divider {
  width: 60px;
  height: 1px;
  background-color: $color-accent;
  margin: $spacing-block-lg auto;
}

.invites__contact {
  h2 {
    margin-bottom: $spacing-element;
  }

  p {
    @include body-text;
    max-width: 550px;
    margin: 0 auto;

    strong {
      font-weight: 400;
    }
  }
}
</style>
